import React, { Component } from 'react';
import { IresumeData } from '../../../ResumeData';

export default class About extends Component<IresumeData> {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <React.Fragment>
        <section id="about" className="s-about target-section">
          <div className="row">
            <div className="column large-3 tab-12">
              <img
                className="s-about__pic"
                src="images/avatars/avatar.jpg"
                alt=""
              />
            </div>
            <div className="column large-9 tab-12 s-about__content">
              <h3>About Me</h3>
              <p>
                Hows it going?! My name is {resumeData.name}, I am a
                Software Engineer with experience in a lot of different tech
                positions. I have progressive experience working as a{' '}
                <a className="smoothscroll" href="#resume">
                  <span>Data Engineer</span>,{' '}
                </a>{' '}
                <a className="smoothscroll" href="#resume">
                  <span>Machine Learning Engineer</span>,
                </a>{' '}
                and as a{' '}
                <a className="smoothscroll" href="#resume">
                  <span>Software Engineer</span>
                </a>{' '}
                I currently work at a start up in Houston, Texas where I have
                been working on the full stack platform written in Typescript
                and React. This website is a personal project written in those
                two technologies and showcase that work.
              </p>
              <hr />
              <div className="row s-about__content-bottom">
                <div className="column w-1000-stack">
                  <h3>Contact Details</h3>
                  <p>
                    Robert Quan <br />
                    Apt in the City <br />
                    Houston, TX 77007 US <br />
                    <a href="tel:+1975432345">+919 737 5059</a> <br />
                    <a href="mailto:#hquan212@gmail.com">hquan212@gmail.com</a>
                  </p>
                </div>
                <div className="column w-1000-stack">
                  <a
                    href="https://hquan212-github-io.s3.us-east-2.amazonaws.com/Robert+Quan+Resume+Sofware.pdf"
                    className="btn btn--download"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      style={{
                        fill: 'rgba(0, 0, 0, 1)',
                        transform: '',
                        msFilter: '',
                      }}
                    >
                      <path d="M12 16L16 11 13 11 13 4 11 4 11 11 8 11z" />
                      <path d="M20,18H4v-7H2v7c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2v-7h-2V18z" />
                    </svg>
                    Download CV
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
